module.exports = __webpack_public_path__ + "img/YNGCityGroups.0e85b456.svg";